import React from 'react';
import Icon from '../../Icon';
import ArrowRight from '../../../public/static/images/item/arrow-right.svg';
import { ChevronWrapper } from './styled';

interface ChevronIconProps {
  isOpen?: boolean;
  isDisabled?: boolean;
  width?: number;
  height?: number;
}

export const ChevronIcon: React.FC<ChevronIconProps> = ({
  isOpen = false,
  isDisabled = false,
  width = 7,
  height = 14
}) => (
  <ChevronWrapper $isOpen={isOpen} $isDisabled={isDisabled}>
    {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
    {/* @ts-ignore — Icon is a JSX component without TypeScript types */}
    <Icon
      indent={false}
      height={height}
      width={width}
      IconComponent={ArrowRight}
    />
  </ChevronWrapper>
);
